import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { ShieldCheck, XCircle, Loader2 } from "lucide-react";

export default function VerifyCaregiver() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.post(`/caregiver/verify?token=${encodeURIComponent(token)}`)
      .then(({ data }) => { setInfo(data); setState("done"); })
      .catch(() => setState("error"));
  }, [params]);

  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center">
      <div className="card-metal p-10 flex flex-col items-center gap-4" data-testid="verify-caregiver-status">
        {state === "loading" && <Loader2 className="w-14 h-14 animate-spin text-[#9b111e]" />}
        {state === "done" && (
          <>
            <ShieldCheck className="w-14 h-14 text-green-600" />
            <h1 className="font-heading font-black text-2xl">Caregiver Verified</h1>
            <p className="text-slate-600">
              <b>{info.caregiver_name}</b> ({info.caregiver_email}) can now manage your bookings on Care-4U.net.
            </p>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="w-14 h-14 text-red-600" />
            <h1 className="font-heading font-black text-2xl">Verification Failed</h1>
            <p className="text-slate-600">Invalid link, or the patient must first create a Care-4U account with this email.</p>
          </>
        )}
      </div>
    </div>
  );
}
